import React from "react";

const Loading = () => {
    return (
        <div className='row'>
            <div className="col-12">
                <div className="card">
                    <div className="card__body">
                        <h1>Loading...</h1>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Loading;